import React from "react";
import PropTypes from "prop-types";
import { useLocation, NavLink } from "react-router-dom";

import { getString } from "../../utilities";
import PromoBurst from "./promoBurst";

export default function PlanButton({ color, promo, to }) {
  const location = useLocation();
  const isDefault =
    ["free", "classroom", "school"].every((plan) => !location.pathname.endsWith(plan)) && to === "family";

  return (
    <NavLink
      type="button"
      className={({ isActive }) =>
        `planbutton button-flat-color round ${color} ${isActive || isDefault ? "active" : ""}`
      }
      end
      to={to}
    >
      {getString(`subscribe.plans.${to}.title.0`)}
      <PromoBurst promo={promo} pRole={to} />
    </NavLink>
  );
}

PlanButton.propTypes = {
  color: PropTypes.string.isRequired,
  promo: PropTypes.object,
  to: PropTypes.string.isRequired,
};

PlanButton.defaultProps = {
  promo: null,
};
